<template>
  <b-overlay :show="loading">
    <b-container fluid>

      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">No class selected.</b-alert>

          <div v-if="!error">
            <div class="div-section-header">
              <b-row>
                <b-col cols="12" class="text-center">
                  <countdown v-if="!loading" :serverTime="classObj.serverTime" :endTime="classObj.releaseDateUTC" :alarmSeconds="alarmSeconds" @countdown-alarm="countdownAlarm"></countdown>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="mt-3 mb-3 text-center">
                    <b-overlay :show="reserving" rounded="sm">
                      <b-button variant="danger" @click.prevent="reserveSeat">Reserve Seat</b-button>
                    </b-overlay>
                </b-col>
              </b-row>
            </div>

            <div class="div-section-body div-padding">
              <b-row>
                <b-col cols="4">
                    <b-img fluid v-bind:src="classObj.photo" />
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                  <div class="class-title">{{classObj.className}}</div>
                  <div class="class-details">
                      {{classObj.name}}
                      <br>Sponsor: {{classObj.companyName}}
                      <br>{{classObj.credits}} CEU (Live, Interactive)
                      <br><span class="red">{{classObj.releaseDate | prettyDateTime}}</span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <!-- :inner-html.prop instead of v-html -->
                <b-col class="txt-class-blurb mt-2" :inner-html.prop="this.classObj.description | nl2br"></b-col>
              </b-row>
            </div>

          </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import constants from "@/config/constants"
import Countdown from "@/components/Countdown"

const SECONDS_TO_ACTIVATE_WEBINAR = 60*30  // 60 seconds * 30 minutes

export default {
  name: "Classroom",
  data() {
    return {
      debug: false,
      error: false,
      loading: false,
      alarmSeconds: SECONDS_TO_ACTIVATE_WEBINAR,
      msg: "Classroom",
      blurb: "Classroom blurb.",
      classObj: { status: false, zoomCode: null},
      studentData: {status: false, isReserved: false},
      studentHash: this.$root.getToken(),
      classHash: "",
      reserving: false,
      started: false
    }
  },
  components: {
    Countdown
  },
  props: {
    // route set to use props mapped to url parameters
    c: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    countdownAlarm() {
      this.started = true
      console.log(`Countdown alarm sounded`)
    },
    reloadPage() {
      this.getClass()
    },
    reserveSeat() {
      if (this.debug) console.log(`Redirecting to classroomLive: ${this.classHash}`)
      this.reserving = true

      // Suppress the console navigation guard errors when forward then forwards to login.
      // https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
      this.$router.push(`/live/${this.classHash}`).catch(() => {})
    },
    getClass() {
      this.loading = true
      service
        .getClass(this.classHash, this.studentHash)
        .then(
          (data => {
            if (this.debug) console.log(data)
            if (data.status) {
              this.classObj = data.classObj
              if (this.classObj.typeId !== constants.CLASS_TYPE.LIVE) {
                // Class is not live
                this.$router.push(`/classroom/${this.classObj.hash}`).catch(() => {})
              }
              if (this.classObj.zoomCode === null) { console.log(`ALERT: null zoom code!`)}
              if (data.studentData.status) {
                this.studentData = data.studentData
                if (this.studentData.isReserved) {
                  // student already reserved
                  this.$router.push(`/live/${this.classObj.hash}`).catch(() => {})
                }
              }
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false
          // console.log(`finally...`)
        })
        .catch(e => {
          this.error = true
          console.log(e);
        })
    }
  },
  created() {
    this.classHash = this.c || this.$route.query.c || this.$root.getClassHash() || ''
    if (this.classHash) {
      this.getClass()
    }
    else {
      this.$router.push("/exams").catch(() => {})
    }
  },
  mounted () {
    // console.log('mounted')
  },
  beforeDestroy() {
    this.classObj = {status: false}
    this.studentData = {status: false, isReserved: false}
    this.error = false
    this.loading = true
    this.reserving = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ClassroomReserve.vue